import * as React from 'react';
import styled from 'styled-components';

import { Modal } from '@process-advisor/process-miner/components/modal/modal';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { Text} from '@process-advisor/process-miner/modals/text';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Section } from '@process-advisor/process-miner/modals/section';
import { getShadow } from '@process-advisor/process-miner/shared/theme';
import { type AnalyticModalProps } from '@process-advisor/process-miner/api/methods/modals/analyticModal';

const Wrapper = styled.div`
    box-shadow: ${getShadow('pane')};
    display: grid;
    align-items: baseline;
    grid-template-columns: 75px 400px;
    grid-gap: 10px;
    padding: 5px;
`;

const AnalyticLabel = styled.div`
    grid-row: 1 ;
    grid-column: 1;  
`;

const AnalyticText = styled.div`
    grid-row: 1 ;
    grid-column: 2;  
`;

export const AnalyticModal = () => {
    const [data, setData] = React.useState<{analytic:string}>({ analytic: ''});
    
    const [isOpen, setIsOpen] = React.useState(false);
    const [analytic, setAnalytic] = React.useState<string>('');
    const [applyEnabled,setApplyEnabled,] = React.useState<boolean>(false);

    const onAnalyticChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAnalytic(event.target.value);
    };

    useApiListener(
        Event.openAnalyticModal,
        
        ({ data }: AnalyticModalProps) => {
            setIsOpen(true);
            setAnalytic(data.analytic);
        }
    );

    const onOk = () => {
        apiProvider.updateAnalytic({analytic: analytic})
    };

    return (
        <Modal title='Save Analytic' open={isOpen} onClose={() => setIsOpen(false)} onOk={onOk} width=''>
            <Wrapper>
                <AnalyticLabel>
                    <Section title='Analytic' />
                </AnalyticLabel>
                <AnalyticText>
                    <Text width='400px' height='25px' value={analytic} onChange={onAnalyticChange} />
                </AnalyticText>
            </Wrapper>
        </Modal>
    );
};


